package com.imobly.imobly.viewmodel

import com.imobly.imobly.domain.Payment

object SharedRepository {
    var payment: Payment? = null
}